module.exports = __webpack_public_path__ + "img/OPD-Note27-512.dba562c7.png";